export const VERSION = '0.18.0'

// Use subpaths for actual functionality:
// - flexium-canvas/dom: Canvas, DrawRect, DrawCircle, DrawArc, DrawLine, DrawPath, DrawText
// - flexium-canvas/interactive: useKeyboard, useMouse, useLoop, Keys, MouseButton
